/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

import PropTypes from 'prop-types';

import { Channel } from '../../../core/entities';
import { RecordingRestriction } from '../../../core/usecases';
import { Mousetrap, RestrictionMessage } from '../../common';
import { ImageLoader } from '../../ImageLoader';
import { ImageLoaderTypes } from '../../ImageLoader/ImageLoaderTypes';
import { ChannelCellProps } from './ChannelCellProps';

import './ChannelCell.scss';

const ChannelCell: FunctionComponent<ChannelCellProps> = ({
    channel,
    children,
    highlightId,
}): JSX.Element => {
    const channelObj = Object(channel);
    const { channelNumber, callSign, channelLogoUrl, videoResolution, isSubscribed } = channelObj;

    return (
        <Mousetrap value={highlightId}>
            <div className="channel-cell">
                {children}
                <RestrictionMessage
                    displayType={RecordingRestriction.CHANNEL_CELL}
                    channel={channel as Channel}
                />
                <div
                    className={`channel-number ${!isSubscribed ? 'channel-fadeout' : ''} ${
                        channelNumber && channelNumber.length > 4 ? 'adjust-channel-number' : ''
                    }`}
                    data-testid="channel-number"
                >
                    {channelNumber}
                </div>
                <div
                    className={`stream-type-icon ${videoResolution}`}
                    data-testid="stream-type-icon"
                ></div>
                <div data-testid="guide-channel-branding">
                    <ImageLoader
                        src={channelLogoUrl}
                        imageType={ImageLoaderTypes.CHANNEL_BRANDING_IMAGE}
                        placeholder={callSign}
                    />
                </div>
            </div>
        </Mousetrap>
    );
};

ChannelCell.propTypes = {
    channel: PropTypes.object,
    children: PropTypes.element,
    highlightId: PropTypes.string,
};

export default ChannelCell;
